import { createSlice } from "@reduxjs/toolkit";
import { WorkflowStateType } from "../../../types";
import { getWorkflowDefinition } from "./api";

const initialState: WorkflowStateType = {
    isLoadingWorkflows: false,
    workflows: [],
};

const workflowState = createSlice({
    name: "workflow",
    initialState,
    reducers: {},
    extraReducers: {
        [getWorkflowDefinition.pending.type]: (state) => {
            state.isLoadingWorkflows = true;
        },

        [getWorkflowDefinition.fulfilled.type]: (state, { payload }) => {
            state.isLoadingWorkflows = false;
            state.workflows = payload;
        },

        [getWorkflowDefinition.rejected.type]: (state) => {
            state.isLoadingWorkflows = false;
        },
    },
});

export const {} = workflowState.actions;

export default workflowState.reducer;
